import { DD_CLIENT_KEY, ENV, TAG } from 'src/constants/env';

const LOGGING_ENDPOINT = 'https://browser-intake-datadoghq.eu/api/v2/logs';

const DEFAULT_TAGS = [
  `env:${ENV}`,
  `version:${String(TAG).split('-')[0]}`,
  'service:widget-integrations',
  'api:fetch-keepalive',
].join(',');

const DATADOG_BASE_URL = new URL(LOGGING_ENDPOINT);
DATADOG_BASE_URL.searchParams.append('ddsource', 'browser');
DATADOG_BASE_URL.searchParams.append('ddtags', DEFAULT_TAGS);
DATADOG_BASE_URL.searchParams.append('dd-api-key', DD_CLIENT_KEY ?? '');

export { DATADOG_BASE_URL, DEFAULT_TAGS };
